import styled from 'styled-components';
import { colors } from '../../../utils';

const { primaryText } = colors;

export const UploadFileDiv = styled.div`
	margin-top: 0.5rem;
	margin-left: 0.6rem;
	// width: 80%;
	// position: relative;
	display: ${(props) => (props.center ? 'flex' : 'block')};
  justify-content: ${(props) => (props.center ? 'center' : 'initial')};

	@media screen and (max-width: 767px) {
		width: 100%;
		margin-left: 0;
	}

	@media screen and (max-width: 600px) {
		margin-left: 0;
		width: 100%;
	}
`;

export const UploadFile = styled.label`
	background-color: ${primaryText};
	color: #333;
	padding: 1rem 1rem;
	width: fit-content;
	font-weight: 500;
	font-size: 14px;
	letter-spacing: 0.02em;
	border-radius: 0.6rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;
	-moz-box-shadow: inset 0.5px 2px 6px rgba(0, 0, 0, 0.2);
	-webkit-box-shadow: inset 0.5px 2px 6px rgba(0, 0, 0, 0.2);
	box-shadow: inset 0.5px 2px 6px rgba(0, 0, 0, 0.2);

	@media screen and (max-width: 767px) {
		width: 100%;
	}

	@media screen and (max-width: 600px) {
		width: 100%;
	}
`;

export const ShowImage = styled.div`
	// position: absolute;
	margin: 1rem 0;
	display:block;
`;

export const ShowImageEdit = styled.div`
	margin-top: 2rem;
	text-align: center;
	position: absolute;
	left: 30px;

	@media screen and (max-width: 600px) {
		left: 35%;
	}

	@media screen and (max-width: 400px) {
		left: 2px;
	}
`;

export const HorizontalContentDiv = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	height: ${(props) => (props.height ? props.height : 'auto')};
	width: ${(props) => (props.width ? props.width : 'auto')};
	background-color: ${(props) => props.backgroundColor && props.backgroundColor};
	border-radius: ${(props) => props.borderRadius && props.borderRadius};
`;
